import { api } from "./useApi";
import { Brinde } from "../types/Brinde";

export const brindesApi = () => ({
    async listar() {
        return api.post("brindes/listar");
    },
    async salvar(brinde: Brinde) {
        return api.post("brindes/salvar", { brinde });
    },
    async ativar(id: number, ativo: boolean) {
        return api.post("brindes/ativar", { id, ativo });
    },
    async excluir(id: number) {
        return api.post("brindes/excluir", { id });
    },
});
